export enum MasterOperatorType {
  Master = 'master',
  Operator = 'operator',
}
